import { connect } from 'react-redux';
import {
    clickPrev,
    clickNext,
    clickClose,
} from '@/shared/components/photo_gallery/actions';
import Modal from '@/shared/components/photo_gallery/components/modal';

// Component へ渡すパラメータ値
const mapStateToProps = state => {
    return {
        photo:
            state.modal.index == null
                ? null
                : state.gallery.filteredPhotos[state.modal.index],
        index: state.modal.index,
        total: state.gallery.filteredPhotos.length,
    };
};

// Component へ渡す Action
const mapDispatchToProps = dispatch => {
    return {
        clickClose: (...args) => dispatch(clickClose(...args)),
        clickPrev: (...args) => dispatch(clickPrev(...args)),
        clickNext: (...args) => dispatch(clickNext(...args)),
    };
};

// Component へパラメータを渡す
const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Modal);

export default connected;
